



// import * as React from "react";
// import {
//   AppBar,
//   Box,
//   Toolbar,
//   Typography,
//   Button,
//   IconButton,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   Grid,
//   useMediaQuery,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import Sidebar from "./Sidebar";
// import { ApiUrl } from "../ApiUrl";
// import { useTheme } from "@mui/material/styles";

// function Navbar({ onLogout }) {
//   const [state, setState] = React.useState({ left: false });
//   const [academicSession, setAcademicSession] = React.useState("");
//   const [academicYears, setAcademicYears] = React.useState([]);
//   const [currentDateTime, setCurrentDateTime] = React.useState("");

//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

//   React.useEffect(() => {
//     const fetchAcademicYears = async () => {
//       try {
//         const response = await fetch(
//           `${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`
//         );
//         const data = await response.json();
//         if (data.message === "Success") {
//           const formattedYears = data.data.map((year) => ({
//             id: year.id,
//             code: year.sesion_code,
//             orgId: year.org_id || null,
//             branchId: year.branch_id || null,
//             dateFrom: new Date(year.date_from),
//             dateTo: new Date(year.date_to),
//           }));
//           setAcademicYears(formattedYears);

//           const storedSessionId = localStorage.getItem("academicSessionId");
//           let currentYearData = null;

//           if (storedSessionId) {
//             currentYearData = formattedYears.find(
//               (year) => year.id.toString() === storedSessionId
//             );
//           } else {
//             const currentDate = new Date();
//             currentYearData = formattedYears.find(
//               (year) =>
//                 currentDate >= year.dateFrom && currentDate <= year.dateTo
//             );
//           }

//           if (currentYearData) {
//             setAcademicSession(currentYearData.code);
//             localStorage.setItem("academicSessionId", currentYearData.id);
//             localStorage.setItem("orgId", currentYearData.orgId || "");
//             localStorage.setItem("branchId", currentYearData.branchId || "");
//             localStorage.setItem(
//               "dateFrom",
//               currentYearData.dateFrom.toISOString().split("T")[0]
//             );

//             const nextYear = formattedYears.find(
//               (year) => year.dateFrom > currentYearData.dateTo
//             );
//             if (nextYear) {
//               localStorage.setItem("nextAcademicSessionId", nextYear.id);
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching academic years:", error);
//       }
//     };

//     fetchAcademicYears();
//   }, []);

//   React.useEffect(() => {
//     const updateTime = () => {
//       const now = new Date();
//       const formatted = now.toLocaleString("en-US", {
//         weekday: "short",
//         year: "numeric",
//         month: "short",
//         day: "numeric",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//         hour12: true,
//       });
//       setCurrentDateTime(formatted);
//     };
//     updateTime();
//     const interval = setInterval(updateTime, 1000);
//     return () => clearInterval(interval);
//   }, []);

//   const handleSessionChange = (e) => {
//     const selectedCode = e.target.value;
//     setAcademicSession(selectedCode);
//     const selectedYear = academicYears.find(
//       (year) => year.code === selectedCode
//     );

//     if (selectedYear) {
//       localStorage.setItem("academicSessionId", selectedYear.id);
//       localStorage.setItem("orgId", selectedYear.orgId || "");
//       localStorage.setItem("branchId", selectedYear.branchId || "");

//       const nextYearCode = `${parseInt(selectedYear.code.split("-")[0]) + 1}-${(
//         parseInt(selectedYear.code.split("-")[1]) + 1
//       )
//         .toString()
//         .slice(-2)}`;
//       const nextYear = academicYears.find((year) => year.code === nextYearCode);
//       if (nextYear) {
//         localStorage.setItem("nextAcademicSessionId", nextYear.id);
//       }

//       window.dispatchEvent(new Event("academicSessionChanged"));
//     }
//   };

//   const handleLogout = () => {
//     const confirmed = window.confirm("Are you sure you want to logout?");
//     if (confirmed) {
//       sessionStorage.clear();
//       localStorage.clear();
//       window.location.href = "/login";
//     }
//   };


//  return (
//     <Box sx={{ flexGrow: 1 }}>
//       <AppBar position="static">
//         <Toolbar>
//           <Grid container alignItems="center" justifyContent="space-between">
//             {/* Sidebar toggle icon - Left */}
//             <Grid item xs="auto">
//               <IconButton
//                 size="large"
//                 edge="start"
//                 color="inherit"
//                 aria-label="menu"
//                 onClick={() => setState({ ...state, left: true })}
//               >
//                 <MenuIcon />
//               </IconButton>
//             </Grid>

//             {/* Academic Session - Centered */}
//             <Grid item xs={12} sm={6} md={4}>
//               <Box
//                 display="flex"
//                 alignItems="center"
//                 justifyContent="center"
//                 sx={{ width: "100%" }}
//               >
//                 <Typography variant="body1" sx={{ color: "#fff", mr: 1 }}>
//                   Academic Session:
//                 </Typography>
//                 <FormControl size="small" sx={{ minWidth: 140 }}>
//                   <InputLabel sx={{ color: "#fff" }}>Select Session</InputLabel>
//                   <Select
//                     value={academicSession}
//                     onChange={handleSessionChange}
//                     label="Select Session"
//                     sx={{ color: "#fff" }}
//                   >
//                     {academicYears.map((year) => (
//                       <MenuItem key={year.id} value={year.code}>
//                         {year.code}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Box>
//             </Grid>

//             {/* Time & Logout - Right */}
//             <Grid item xs="auto">
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <Typography variant="body2" sx={{ color: "#fff" }}>
//                   {currentDateTime}
//                 </Typography>
//                 <Button
//                   color="inherit"
//                   onClick={handleLogout}
//                   sx={{
//                     border: "1px solid white",
//                     padding: "4px 12px",
//                     fontSize: "0.875rem",
//                   }}
//                 >
//                   Logout
//                 </Button>
//               </Box>
//             </Grid>
//           </Grid>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar Drawer */}
//       <Sidebar state={state} setState={setState} toggleDrawer={() => {}} />
//     </Box>
//   );

// }

// export default Navbar;


import * as React from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "./Sidebar";
import { ApiUrl } from "../ApiUrl";
import { useTheme } from "@mui/material/styles";

function Navbar({ onLogout }) {
  const [state, setState] = React.useState({ left: false });
  const [academicSession, setAcademicSession] = React.useState("");
  const [academicYears, setAcademicYears] = React.useState([]);
  const [currentDateTime, setCurrentDateTime] = React.useState("");

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  React.useEffect(() => {
    const fetchAcademicYears = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`
        );
        const data = await response.json();
        if (String(data.message || "").toLowerCase() === "success") {
          const formattedYears = (data.data || [])
            .map((year) => ({
            id: year.id,
            code: year.sesion_code,
            orgId: year.org_id || null,
            branchId: year.branch_id || null,
            dateFrom: new Date(year.date_from),
            dateTo: new Date(year.date_to),
            }))
            .sort((a, b) => a.dateFrom - b.dateFrom);

          if (!formattedYears.length) {
            return;
          }

          setAcademicYears(formattedYears);

          const storedSessionId = localStorage.getItem("academicSessionId");
          let currentYearData = null;

          if (storedSessionId) {
            currentYearData = formattedYears.find(
              (year) => year.id.toString() === storedSessionId
            );
          }

          if (!currentYearData) {
            const currentDate = new Date();
            currentYearData = formattedYears.find(
              (year) =>
                currentDate >= year.dateFrom && currentDate <= year.dateTo
            );
          }

          if (!currentYearData) {
            currentYearData = formattedYears[formattedYears.length - 1];
          }

          if (currentYearData) {
            setAcademicSession(currentYearData.code);
            localStorage.setItem("academicSessionId", currentYearData.id);
            localStorage.setItem("orgId", currentYearData.orgId || "");
            localStorage.setItem("branchId", currentYearData.branchId || "");
            localStorage.setItem(
              "dateFrom",
              currentYearData.dateFrom.toISOString().split("T")[0]
            );

            const currentYearIndex = formattedYears.findIndex(
              (year) => year.id === currentYearData.id
            );
            const nextYear = formattedYears[currentYearIndex + 1];
            if (nextYear) {
              localStorage.setItem("nextAcademicSessionId", nextYear.id);
            } else {
              localStorage.removeItem("nextAcademicSessionId");
            }

            window.dispatchEvent(new Event("academicSessionChanged"));
          }
        }
      } catch (error) {
        console.error("Error fetching academic years:", error);
      }
    };

    fetchAcademicYears();
  }, []);

  React.useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formatted = now.toLocaleString("en-US", {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      });
      setCurrentDateTime(formatted);
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleSessionChange = (e) => {
    const selectedCode = e.target.value;
    setAcademicSession(selectedCode);
    const selectedYear = academicYears.find(
      (year) => year.code === selectedCode
    );

    if (selectedYear) {
      localStorage.setItem("academicSessionId", selectedYear.id);
      localStorage.setItem("orgId", selectedYear.orgId || "");
      localStorage.setItem("branchId", selectedYear.branchId || "");

      const selectedIndex = academicYears.findIndex(
        (year) => year.id === selectedYear.id
      );
      const nextYear =
        selectedIndex >= 0 ? academicYears[selectedIndex + 1] : null;
      if (nextYear) {
        localStorage.setItem("nextAcademicSessionId", nextYear.id);
      } else {
        localStorage.removeItem("nextAcademicSessionId");
      }

      window.dispatchEvent(new Event("academicSessionChanged"));
    }
  };

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Grid container alignItems="center" justifyContent="space-between">
            {/* Sidebar toggle icon - Left */}
            <Grid item xs="auto">
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                disableRipple
                disableFocusRipple
                onClick={() => setState({ ...state, left: true })}
                sx={{
                  "&:hover": { backgroundColor: "transparent" }, // removes hover grey
                }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>

            {/* Academic Session - Centered */}
            <Grid item xs={12} sm={6} md={4}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ width: "100%" }}
              >
                <Typography variant="body1" sx={{ color: "#fff", mr: 1 }}>
                  Academic Session:
                </Typography>
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel sx={{ color: "#fff" }}>Select Session</InputLabel>
                  <Select
                    value={academicSession}
                    onChange={handleSessionChange}
                    label="Select Session"
                    sx={{ color: "#fff" }}
                  >
                    {academicYears.map((year) => (
                      <MenuItem key={year.id} value={year.code}>
                        {year.code}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>

            {/* Time & Logout - Right */}
            <Grid item xs="auto">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Typography variant="body2" sx={{ color: "#fff" }}>
                  {currentDateTime}
                </Typography>
                <Button
                  color="inherit"
                  onClick={handleLogout}
                  sx={{
                    border: "1px solid white",
                    padding: "4px 12px",
                    fontSize: "0.875rem",
                  }}
                >
                  Logout
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>

      {/* Sidebar Drawer */}
      <Sidebar state={state} setState={setState} toggleDrawer={() => {}} />
    </Box>
  );
}

export default Navbar;

